import { backToNative, setNavigationBar } from '@docs/common'
import { useTranslation } from '@volcengine/i18n'
import React, { useEffect, useState } from 'react'
import Helmet from 'react-helmet'

import HB3StorageArchive from 'pages/HB3Storage/Archive'
import HB3StorageExpanding from 'pages/HB3Storage/Expanding'
import HB3StorageFormating from 'pages/HB3Storage/Formating'
import HB3StorageInstallation from 'pages/HB3Storage/Installation'

import { ReactComponent as BackIcon } from '../../assets/images/back.svg'
import { getLanguage } from '../../common/useLanguageTrans'

import { useAsyncEffect } from 'ahooks'
import styles from './index.module.scss'

enum Modal {
  Expanding,
  Installation,
  Formatting,
  Archive,
}

type IFeature = (typeof FEATURES)[0]

const FEATURES = [
  {
    title_key: 'h5_storage_edu_expanding',
    descritption_key: 'h5_storage_edu_expanding_content',
    title: 'Expanding Storage',
    descritption: 'When using an additional storage drive, HomeBase can store more video recordings.',
    class: 'StorageExpanding',
    modal: Modal.Expanding,
    url: '/hb3storage/expanding',
  },
  {
    title_key: 'h5_storage_edu_install',
    descritption_key: 'h5_storage_edu_install_content',
    title: 'Storage Drive Installation',
    descritption: 'Steps and Tips for Storage Drive Installation',
    class: 'HardDriveInstallation',
    modal: Modal.Installation,
    url: '/hb3storage/installation',
  },
  {
    title_key: 'h5_storage_edu_format',
    descritption_key: 'h5_storage_edu_format_content',
    title: 'Storage Drive Formatting',
    descritption: 'How to format the storage drive.',
    class: 'HardDriveFormatting',
    modal: Modal.Formatting,
    url: '/hb3storage/formating',
  },
  {
    title_key: 'h5_storage_edu_archive',
    descritption_key: 'h5_storage_edu_archive_content',
    title: 'Video Archive',
    descritption: 'Backup video recordings from HomeBase.',
    class: 'VideoArchive',
    modal: Modal.Archive,
    url: '/hb3storage/archive',
  },
]

// const FAQS = [
//   {
//     descritption: "What if no hard drive is displayed on HomeBase 3's storage page after a hard drive has been added?"
//   },
//   {
//     descritption: "What if videos aren't being recorded after a hard drive has been added?"
//   },
//   {
//     descritption: "What if videos stop recording after using a hard drive for a while?"
//   }
// ]

const HB3Storage = () => {
  const [visible, setVisible] = useState(false)
  const [feature, setFeature] = useState<IFeature | undefined>(undefined)
  const [languageChanged, setLanguageChanged] = useState(false)
  // useLanguageTrans()
  const { t,i18n } = useTranslation()
  const lang = getLanguage()
  console.log({ lang })
  const handleClickFeature = (feat: IFeature) => {
    setVisible(true)
    setFeature(feat)
  }

  useEffect(() => {
    if(!languageChanged) return
    setNavigationBar({
      title: t('h5_storage_edu_title', { defaultValue: 'About HomeBase Storage' }),
      onBack: () => {
        backToNative()
      },
    })
  })
  useAsyncEffect(async () => {
    await i18n.changeLanguage(lang)
    setLanguageChanged(true)
  }, [i18n, lang])
  if (!languageChanged) {
    return null
  }

  return (
    <React.Fragment>
      <Helmet>
        <meta name="viewport"  content='width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no'/>
      </Helmet>
      <div className={styles.HB3}>
        <div className={styles.HB3Features}>
          {FEATURES.map((item, i) => (
            <div className={styles.FeaturesCell} key={i} onClick={() => handleClickFeature(item)}>
              <i className={styles[item.class]}></i>
              <div className={styles.FeaturesCellText}>
                <h3>{t(item.title_key, { defaultValue: item.title })}</h3>
                <p>{t(item.descritption_key, { defaultValue: item.descritption })}</p>
              </div>
            </div>
          ))}
        </div>
        {/* <h2>FAQ</h2>
        <div className={styles.HB3Faqs}>
          {FAQS.map((item, i) => (
            <div className={styles.FaqsCell} key={i}>
              <p>{item.descritption}</p>
              <i></i>
            </div>
          ))}
        </div> */}
      </div>
      <div className={styles.Drawer} style={{ transform: visible ? undefined : `translateX(100%)` }}>
        <div className={styles.DrawerNav}>
          <i onClick={() => setVisible(false)}>
            <BackIcon />
          </i>
          <span>{feature?.title}</span>
        </div>
        {feature?.modal === Modal.Expanding && <HB3StorageExpanding />}
        {feature?.modal === Modal.Installation && <HB3StorageInstallation />}
        {feature?.modal === Modal.Formatting && <HB3StorageFormating />}
        {feature?.modal === Modal.Archive && <HB3StorageArchive />}
      </div>
    </React.Fragment>
  )
}

export default HB3Storage
